'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002419 from "./presto.-Agent-View$$anon$19.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Cert-Chain-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$18() {
  this.axo = null;
  this.axg = null;
  this.axh = false;
  this.axp = null;
  this.axq = false;
  this.axt = null;
  this.axm = null;
  this.axn = false;
  this.axi = null;
  this.axj = false;
  this.axk = null;
  this.axl = false;
  this.axr = false;
  this.axs = false;
  this.axo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axt = "LocalPjeOfficeCertChainRequest";
}
export { $c_Lpresto_AgentView$$anon$18 as $c_Lpresto_AgentView$$anon$18 };
$p = $c_Lpresto_AgentView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$18;
/** @constructor */
function $h_Lpresto_AgentView$$anon$18() {
}
export { $h_Lpresto_AgentView$$anon$18 as $h_Lpresto_AgentView$$anon$18 };
$h_Lpresto_AgentView$$anon$18.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.axo;
});
$p.M = (function() {
  if ((!this.axh)) {
    this.axg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axh = true;
  }
  return this.axg;
});
$p.O = (function() {
  if ((!this.axq)) {
    this.axp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axq = true;
  }
  return this.axp;
});
$p.D = (function() {
  return this.axt;
});
$p.t = (function() {
  if ((!this.axn)) {
    this.axm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.axn = true;
  }
  return this.axm;
});
$p.N = (function() {
  if ((!this.axj)) {
    this.axi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fi(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.axj = true;
  }
  return this.axi;
});
$p.Q = (function() {
  if ((!this.axl)) {
    this.axk = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002419.$c_Lpresto_AgentView$$anon$19();
    this.axl = true;
  }
  return this.axk;
});
$p.v = (function() {
  if ((!this.axs)) {
    this.axr = false;
    this.axs = true;
  }
  return this.axr;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee120) => ((p) => \u03b4scrutinee120.cGO(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$())));
});
var $d_Lpresto_AgentView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$18, "presto.AgentView$$anon$18", ({
  DM: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$18 as $d_Lpresto_AgentView$$anon$18 };
//# sourceMappingURL=presto.-Agent-View$$anon$18.js.map
